module.exports = __webpack_public_path__ + "static/media/4.510f0309.jpg";